import {MediaFile} from "types/MediaFile";
import {dateTime} from "services/date";
import {Duration} from "luxon";

/**
 * Transform the given file by deserializing object properties
 *
 * @internal
 * @param file
 */
export default function deserializeFile(file: any): MediaFile {
    file.created_at = dateTime(file.created_at)
    file.updated_at = dateTime(file.updated_at)

    if (file.duration) {
        file.duration = Duration.fromDurationLike(
            file.duration > 59? {minute: 0, second: file.duration} : {second: file.duration}
        ).normalize()
    }

    return file;
}